/* eslint-disable camelcase */
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';

/* Log environment */
let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
console.log('ENVIRONMENT: ', env);

/* Connect to firebase project (same for test & production, no demo) */
const firebaseConfig = {
	apiKey: 'AIzaSyDOkzCktSZ7ON42b47mhueMOWmoZUS5D1M',
	authDomain: 'cgl-elevspilkort-test.firebaseapp.com',
	projectId: 'cgl-elevspilkort-test',
	storageBucket: 'cgl-elevspilkort-test.firebasestorage.app',
	messagingSenderId: '184317570269',
	appId: '1:184317570269:web:c2125776a2957c29867f34'
};


/* Initialize firebase */
firebase.initializeApp(firebaseConfig);

export default firebase.firestore;